module.exports = styled;